import React, { useState, useEffect } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.css";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import Response_Loading_processing from "../../../../src/layout/Others/Response_Loading_processing";
import { MdKeyboardDoubleArrowLeft, MdKeyboardDoubleArrowRight } from "react-icons/md";
import axios from "axios";
import { toast } from "react-toastify";
// import Select from 'react-select';
import { useLocation } from "react-router-dom";
import AdminTable from "../../../components/CommonComponents/AdminTable";
import { useMyContext } from "../../../components/Provider/CommonProvider";
import Select, { components } from "react-select";

const AssignPartnerToContent = () => {
    const location = useLocation();
    const [loading, setLoading] = useState(true);
    const [showOverlay, setShowOverlay] = useState(false);
    const [filter, setFilter] = useState("");
    const [apiResponse, setApiResponse] = useState(null);
    const [allData, setAllData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [previousPartners, setPreviousPartners] = useState([]);
    const access_token = localStorage.getItem("access_token");
    const [activeDropdownId, setActiveDropdownId] = useState(null);
    const selectOptions = [
        { value: 'video', label: 'Videos', source_type_id: 1 },
        { value: 'livestream', label: 'Livestreams', source_type_id: 2 },
        { value: 'series', label: 'Series', source_type_id: 3 },
        { value: 'episode', label: 'Episodes', source_type_id: 4 },
        { value: 'audio', label: 'Audios', source_type_id: 5 },
    ];
    const headers = {
        "Content-Type": "application/json", Authorization: "Bearer " + access_token,
        Accept: "application/json", "Access-Control-Allow-Origin": "*"
    };                      

    const { fetchRequest } = useMyContext();
    const BaseUrl = process.env.REACT_APP_Baseurl
    const listApi = `${BaseUrl}/admin/partner/filter-source`

    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [type, setType] = useState(null);
    const [total, setTotal] = useState('');
    const [itemToDelete, setItemToDelete] = useState([]);
    const [selectSourcetype, setSelectSourcetype] = useState(selectOptions[0]);

    const multiSelectLabel = (array, valueKey, labelKey) => {
        return Array.isArray(array) ? array?.map((item) => ({
            value: item[valueKey],
            label: item[labelKey]
        })) : [];
    };
    const handlePageChange = (page) => {
        setPage(page);
    };

    const handleSizePerPageChange = (e) => {
        setLimit(Number(e.target.value));
        setPage(1);
    };
    const [formData, setFormData] = useState({
        state: "formData",
        view_type: "list",
        view_type_option: [{
            name: "List",
            value: "list"
        },
        {
            name: "Gallery",
            value: "grid"
        }]
    })

    const fetchData = async () => {
        try {
            setLoading(true);
            console.log("Selected:", selectSourcetype?.source_type_id);
    
            const response = await fetchRequest({
                method: "POST",
                url: `${listApi}`,
                params: {
                    type,
                    page,
                    limit,
                    title: formData?.title,
                    source_type_id: selectSourcetype?.source_type_id
                },
            });
    
            const result = response;
            const partner = multiSelectLabel(response?.Partners, 'id', 'username');
            const part = response?.data.map((item) => ({
                ...item,
                assigned: multiSelectLabel(item?.assigned_partners, 'id', 'username'),
                partner: [...partner],
                selectedpartner: [],
                primary_partner: multiSelectLabel(item?.primary_partner, 'id', 'username'),
                selectedprimary: [],
                assignedprimary: multiSelectLabel(item?.primary_partner, 'id', 'username'),
            }));
    
            setAllData(part);
            setPage(result?.pagination?.currentPage || 1);
            setTotal(result?.pagination || null);
        } catch (error) {
            console.error("Fetch error:", error);
        } finally {
            setLoading(false);
        }
    };
    


    const handleFilterChange = (event) => {
        const searchTerm = event.target.value.toLowerCase();
        setFilter(searchTerm);
        const filteredResults = allData?.filter((item) =>
            Object.values(item).some((value) => value?.toString().toLowerCase().includes(searchTerm)));
        setAllData(filteredResults);
    };
    const handleClear = () => {
        setFilter("");
        // fetchData("video");
    };

    const assignPartners = async (id, type, value, primaryId) => {

        const newPartnerValues = value?.map(option => option?.value);
        const prevPartnerValues = previousPartners;
        const formattedType = type?.charAt(0).toUpperCase() + type?.slice(1);
        let message = "";

        if (prevPartnerValues?.length === 0 && newPartnerValues?.length > 0) {
            message = `The ${formattedType} Assigned to the Partner Successfully`;
        } else if (prevPartnerValues?.length > 0 && newPartnerValues?.length === 0) {
            message = `The ${formattedType} Removed from the Partner Successfully`;
        } else if (
            prevPartnerValues?.length > 0 &&
            newPartnerValues?.length > 0 &&
            JSON.stringify(prevPartnerValues) !== JSON.stringify(newPartnerValues)
        ) {
            message = `The ${formattedType} Changed for the Partner Successfully`;
        }

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_Baseurl}/admin/partner/store-source`,
                {
                    source_id: id,
                    source_type_id: selectSourcetype?.source_type_id,
                    partner_id: newPartnerValues.join(","),
                    primary_partner_id: primaryId?.value
                }, { headers: headers }
            );

            if (response.status) {
                if (message) toast.success(message);
                if (primaryId?.value) {
                    toast.success("Primary Partner Assigned Successfully");
                }

                setApiResponse((prev) => !prev);
                setPreviousPartners(newPartnerValues); // Update previous values after success
                fetchData();
            } else {
                console.error("Failed to update partners:", response);
            }
        } catch (error) {
            console.error("Error in assigning partners:", error);
        }
    };
    const [selectedPrimaryPartners, setSelectedPrimaryPartners] = useState({});

    const handlePrimaryChange = (rowId, selectedOption) => {
        setSelectedPrimaryPartners(prev => ({
            ...prev,
            [rowId]: selectedOption,
        }));

        setAllData((prevData) =>
            prevData.map((row) => {
                if (row.id === rowId) {
                    return {
                        ...row,
                        selectedprimary: selectedOption,
                        assignedprimary: selectedOption,
                    };
                }
                return row;
            })
        );
    };


    const handleAssignChange = (rowId, selectedOptions) => {
        setAllData((prevData) =>
            prevData.map((row) => {
                if (row.id === rowId) {
                    const previousAssigned = row.assigned || [];
                    const newAssigned = selectedOptions || [];
                    return {
                        ...row,
                        selectedpartner: newAssigned.map((option) => option.value).join(","),
                        assigned: selectedOptions,

                    };
                }
                return row;
            })
        );
    };

    const columns = [
        {
            dataField: "title",
            text: "Title",
            sort: true,
            formatter: (cell, row) => {
                const maxLength = 30;
                const truncated = cell?.length > maxLength ? cell.slice(0, maxLength) + "..." : cell;
                return (
                    <span title={cell}>
                        {truncated}
                    </span>
                );
            }
        }
        ,
        {
            dataField: "assigned_partners", text: "Partner Assigned", sort: true,
            formatter: (cell, row) => {
                if (row?.assigned_partners && row?.assigned_partners?.length > 0) {
                    return row?.assigned_partners
                        .map((partner) => `${partner?.username}`)
                        .join(", ");
                }
                return "No Partner Assigned";
            }
        },
        {
            dataField: "",
            text: "Primary Partner",
            formatter: (cell, row) => {
                const rowId = row.id;
                const selectedValue =
                    selectedPrimaryPartners[rowId] ??
                    (Array.isArray(row.assignedprimary) && row.assignedprimary.length > 0
                        ? row.assignedprimary[0]
                        : null);
                const updatedOptions = row?.partner?.map(option => ({
                    ...option,
                    isDisabled: selectedValue && option.value !== selectedValue.value,
                }));

                return (
                    <Select
                        className="basic-single"
                        classNamePrefix="select"
                        options={updatedOptions}
                        value={selectedValue}
                        isClearable={true}
                        isMulti={false}
                        placeholder="Select Primary"
                        name={`primary_partner_${rowId}`}
                        closeMenuOnSelect={true}
                        hideSelectedOptions={false}
                        onChange={(selectedOption) => handlePrimaryChange(rowId, selectedOption)}
                        styles={{
                            clearIndicator: (base, state) => ({
                                ...base,
                                color: 'black',
                                padding: '0 8px',
                                display: state.selectProps.isClearable ? 'flex' : 'none',
                            }),
                            dropdownIndicator: (base) => ({
                                ...base,
                                color: 'black',
                                padding: '0 8px',
                            }),
                            indicatorsContainer: (base) => ({
                                ...base,
                                display: 'flex',
                            }),
                        }}
                    />
                );
            }
        },
        {
            dataField: "",
            text: "Assign Partner",
            formatter: (cell, row) => {
                // Ensure assignedprimary is an array for easier comparison
                const assignedPrimary = Array.isArray(row?.assignedprimary)
                    ? row.assignedprimary
                    : [row?.assignedprimary];

                // Map partner options and disable if matched with assignedPrimary
                const partnerOptions = row?.partner?.map(option => ({
                    ...option,
                    isDisabled: assignedPrimary.some(ap => ap?.value === option?.value)
                })) || [];

                return (
                    <Select
                        options={partnerOptions}
                        value={row?.assigned}
                        isClearable={true}
                        isMulti
                        placeholder="Assign Partners"
                        name="assigned_partners"
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                        onChange={(selectedOptions) => handleAssignChange(row.id, selectedOptions)}
                        className="custom-select-multi custom-placeholder theme-text-color custom-select-width"
                        activeDropdownId={activeDropdownId}
                        currentRowId={row.id}
                    />
                );
            }
        },
        {
            dataField: "action",
            text: "Action",
            formatter: (cell, row) => (
                <button onClick={() => { assignPartners(row?.id, row?.title, row?.assigned, row?.selectedprimary) }} className="btn btn-primary">
                    Update
                </button>
            ),
        },
    ];

    const pagination = paginationFactory({
        page: currentPage,
        sizePerPage: 10,
        nextPageText: "Next",
        prePageText: "Prev",
        firstPageText: <MdKeyboardDoubleArrowLeft />,
        lastPageText: <MdKeyboardDoubleArrowRight />,
        showTotal: true,
        alwaysShowAllBtns: true,
        sizePerPageList: [
            { text: "5", value: 5 },
            { text: "10", value: 10 },
            { text: "All", value: allData?.length },
        ],
    });

    const options = {
        pageStartIndex: 1,
        paginationSize: 3,
        sizePerPage: 10,
        sizePerPageList: [
            { text: '5', value: 5 },
            { text: '10', value: 10 },
            { text: 'All', value: total?.totalItems }
        ]
    };
    const handleSort = (field) => {
        const sortedData = [...allData].sort((a, b) => {
            if (a[field] < b[field]) return -1;
            if (a[field] > b[field]) return 1;
            return 0;
        });
        setAllData(sortedData);
    };
    const handleDropdownChange = (selectedOption) => {
        setSelectSourcetype(selectedOption);
    };
    useEffect(() => {
        fetchData();
    }, [page]);

   

    return (
        <> <div>{showOverlay && <Response_Processing />}</div>
            <div className="m-0 p-0">
                <div> <section className="section container-fluid pt-3">
                    <div id="content-page" className="content-page">
                        <div className="iq-card-header d-flex justify-content-between pb-3 flex-wrap">
                            <div className="col-md-6 col-12">
                                <h4>Assign Partners To Contents
                                    <span className="fs-6"> (Display all {allData?.length})</span>
                                </h4>
                            </div>
                        </div>
                        <div className="iq-card">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="d-flex justify-content-between align-items-center flex-wrap mb-3 gap-3">
                                        <div className="filterContainer d-flex align-items-center gap-2">
                                            <Select value={selectSourcetype} onChange={handleDropdownChange}
                                                options={selectOptions} placeholder="Select an option"
                                                className="custom-select-multi custom-placeholder theme-text-color w-100" />
                                            <button onClick={fetchData} className="btn btn-primary"> Submit </button>
                                        </div>
                                        <div className="filterContainer d-flex align-items-center gap-2">
                                            <input type="text" placeholder="Filter all.."
                                                className="form-control" value={filter} onChange={handleFilterChange} />
                                            {filter.length > 0 && (
                                                <button type="button" className="btn btn-outline-secondary" onClick={handleClear} >
                                                    <i className="fa fa-times"></i>
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                    <AdminTable
                                        data={allData}
                                        loading={loading}
                                        options={options}
                                        handlePageChange={handlePageChange}
                                        page={page}
                                        pagination={total}
                                        handleSizePerPageChange={handleSizePerPageChange}
                                        columns={columns}
                                        limit={limit}
                                        onSort={handleSort}
                                        viewType={formData?.view_type}
                                        showcustomStyle={true}
                                    //onSelectAll={handleSelectAll}
                                    //selectRow={selectRow}
                                    //multiSelect
                                    //onRowSelect={handleRowSelect}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                </div>
            </div>
        </>
    );
};

export default AssignPartnerToContent;